import type { Bed, BedCategory } from 'app/typings';
import { BABY_COT_BED_CATEGORY_ID } from 'app/typings';

const SHOWER_FEATURE_ID = 13;
const BATH_FEATURE_ID = 11;
const SHOWER_OR_BATH_FEATURE_ID = 12;

export const maxRoomCapacity = (
  beds: Bed[] | undefined,
  bedCategories: BedCategory[]
) => {
  if (beds && beds.length > 0) {
    const maxCapacity = beds
      .map((b) => {
        if (b.categoryId !== BABY_COT_BED_CATEGORY_ID) {
          return (
            bedCategories.find((bc) => bc.id === b.categoryId)?.capacity || 0
          );
        }

        return 0;
      })
      .reduce((l: number, r: number) => l + r);

    return isNaN(maxCapacity) ? 0 : maxCapacity;
  }

  return 0;
};

export const hasBabyBed = (beds?: Bed[]) => {
  if (beds) {
    const babyBed = beds.find(
      (bed) => bed.categoryId === BABY_COT_BED_CATEGORY_ID
    );

    return !!babyBed;
  }

  return false;
};

export const getBlockedBathroomFeatures = (
  selectedFeatureIds: number[]
): number[] => {
  const blocked: number[] = [];

  if (selectedFeatureIds.includes(SHOWER_OR_BATH_FEATURE_ID)) {
    blocked.push(SHOWER_FEATURE_ID, BATH_FEATURE_ID);
  }

  if (
    selectedFeatureIds.includes(SHOWER_FEATURE_ID) ||
    selectedFeatureIds.includes(BATH_FEATURE_ID)
  ) {
    blocked.push(SHOWER_OR_BATH_FEATURE_ID);
  }

  return blocked;
};
